import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RejectedFile } from '../../../models/rejected-file';

@Component({
  selector: 'app-ignored-files-notice',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ignored-files-notice.component.html',
  styleUrls: ['./ignored-files-notice.component.scss'],
})
export class IgnoredFilesNoticeComponent {
  @Input() files: RejectedFile[] = [];

  expanded = false;
}
